<template>
    <div class="app-container">
        <!-- 工具栏 -->
        <div class="filter-container">

            <!-- 游戏-->
            <div class="filter-data">
                <el-date-picker  unlink-panels class="dataPicker filter-item" :clearable="false" size="small" v-model="dayTimes" format="yyyy-MM-dd" value-format="yyyy-MM-dd" 
                type="daterange" range-separator="~" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期" style="width:230px"></el-date-picker>

                <!-- <div class="label filter-item">游戏：</div> -->
                <el-select class="filter-item" size="small" v-model="appkey" collapse-tags filterable placeholder="游戏" style="width:200px;" >
                    <el-option v-for="item in gameOptions" :key="item.id" :label="item.name" :value="item.appkey"></el-option>
                </el-select>

                <el-select class="filter-item" size="small" v-model="userSource" collapse-tags filterable placeholder="用户来源" style="width:170px;">
                    <!-- <el-option-group
                    v-for="group in userSourceOptions"
                    :key="group.label"
                    :label="group.label"> -->
                    <el-option
                        v-for="item in userSourceOptions"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value">
                        <span style="float: left">{{ item.title }}</span>
                        <span style="float: right; color: #8492a6; font-size: 11px; padding-left: 10px;">{{ item.value }}</span>
                    </el-option>
                    <!-- </el-option-group> -->
                </el-select>

                <el-select class="filter-item" size="small" v-model="client_os" multiple collapse-tags filterable clearable placeholder="平台" style="width:150px;">
                    <el-option v-for="item in client_osOptions" :key="item.id" :label="item.name" :value="item.id" :disabled="item.disabled"></el-option>
                </el-select>
                <el-cascader class="filter-item" filterable size="mini" v-model="media" :options="mediaOptions" :props="{ multiple: true,expandTrigger: 'hover' }" collapse-tags clearable  placeholder="广告媒体" style="width:230px;" :show-all-levels="false" :disabled="disabledAdFilter"></el-cascader>
                
                <!-- <el-button v-if="if_show" id="extend_button" class="filter-item" size="small" plain @click="isOpenMore = !isOpenMore" :icon="isOpenMore?'el-icon-arrow-up':'el-icon-arrow-down'"></el-button> -->

                <div class="filter-item label" style="min-width: 0; margin-right: 10px;">分组</div>
                <el-select class="filter-item" size="small" v-model="groupBy" collapse-tags placeholder="" style="width:120px;">
                    <el-option v-for="item in groupByOptions" :key="item.value" :label="item.title" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
                <!-- 查询 -->
                <div class="filter-data" style="display:inline-flex; margin-left:0">
                    <el-button class="filter-item" size="small" type="primary" icon="el-icon-search" @click="handleFilter" :loading="dataloading">查询</el-button>
                </div>

                <!-- 过滤  -->
                <div class="filter-data" v-if="isOpenMore">
                    <!-- <el-select class="filter-item" size="small" v-model="media" multiple collapse-tags filterable clearable placeholder="广告媒体" style="width:180px;" :disabled="disabledAdFilter">
                        <el-option v-for="item in mediaOptions" :key="item.channelCode" :label="item.name" :value="item.channelCode"></el-option>
                    </el-select> -->

                    <el-select class="filter-item" size="small" v-model="advertiserIds" multiple collapse-tags filterable
                    :filter-method="filterAdvertiserIds" :reserve-keyword="true" clearable placeholder="媒体账号" @visible-change="getFilterData($event,'advertiser_id')" style="width:230px;" :disabled="disabledAdFilter">
                        <el-option v-for="item in advertiserIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>

                    <el-select class="filter-item" size="small" v-model="campaignIds" multiple collapse-tags filterable 
                    :filter-method="filterCampaignIds" :reserve-keyword="true" clearable placeholder="广告组" @visible-change="getFilterData($event,'campaign_id')" style="width:230px;" :disabled="disabledAdFilter">
                        <el-option v-for="item in campaignIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>

                    <el-select class="filter-item" size="small" v-model="adIds" multiple collapse-tags filterable 
                    :filter-method="filterAdIds" :reserve-keyword="true" clearable placeholder="广告计划" @visible-change="getFilterData($event,'ad_id')" style="width:230px;" :disabled="disabledAdFilter">
                        <el-option v-for="item in adIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>

                    <el-select class="filter-item" size="small" v-model="creativeIds" multiple collapse-tags filterable 
                    :filter-method="filterCreativeIds" :reserve-keyword="true" clearable placeholder="广告创意" @visible-change="getFilterData($event,'creative_id')" style="width:230px;" :disabled="disabledAdFilter">
                        <el-option v-for="item in creativeIdsOptions" :key="item.id" :label="item.name+' ['+item.id+']'" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>

        </div>

        <el-dialog title="指标说明" :visible.sync="dialogTipsVisible" width="70%" top="10vh">
        <div style="margin-bottom:15px">
        <span style="color: #8b0000;">**特记**</span><br/>
        所有字段：凡是"比率"概念的数值，一律显示为*100后的%百分值。不管列名是否显示%字样。<br/>
        用户ID类别体系：UA周报，一律使用设备（未使用账号/角色）。<br/>
        汇总行：根据具体的列的含义，进行数据行的汇总计算：如，加和/均值/加权均值。<br/>
        </div>
        <el-table :data="gridTipsData" border highlight-current-row height="600">
            <el-table-column property="title" label="指标" width="150"></el-table-column>
            <el-table-column property="desc" label="定义"></el-table-column>
            <el-table-column property="id_type" label="计算维度" width="150"></el-table-column>
        </el-table>
        </el-dialog>

        <!-- 聚合表 -->
        <el-card class="box-card" shadow="never">
            <!-- <el-tag style="margin-bottom:10rpx;" size="mini" type="danger">此报表中花费来源于广告投放平台绑定过的帐号，请UA同学在投放前绑定投放账号，避免花费数据缺失</el-tag> -->
            <div slot="header" class="clearfix">
                <span style="line-height: 28px;float:left">聚合报表</span>
                <div  style="float:left;font-size:14px;margin-top:7px;margin-left:10px;color:#666" v-html="update_time"></div>
                <div class="right-box" style="float:right">
                    <el-tooltip content="指标说明" placement="top">
                        <el-button size="mini"  @click="dialogTipsVisible = true"><svg-icon icon-class="helps" /></el-button>
                    </el-tooltip>
                    <!-- <el-tooltip content="自定义显示列" placement="top">
                        <el-button size="mini" @click="handleEditNorm"><i class="el-icon-s-grid"></i></el-button>
                    </el-tooltip> -->
                    <el-tooltip content="导出Excel" placement="top">
                        <el-button :loading="downloadLoading" size="mini" @click="handleDownload"><i class="el-icon-download"></i></el-button>
                    </el-tooltip>
                </div>
            </div>
            <el-table class="grayTableTile" v-loading="listLoading" :data="tableData.records" ref="tableAggrReportDataRef"
                max-height="650"
                fit show-summary
                :summary-method="getSummaries"
                sum-text="汇总"
                :default-sort = "{prop: 'daytime', order: 'descending'}"
                :cell-style = "markColumn"
                :header-cell-style = "markHeader"
            >
                <el-table-column v-for="(itemtable,index) in tableData.headers" :key="itemtable.id" :label="itemtable.label" 
                    :property="itemtable.property" :fixed="index==0" :min-width="(itemtable.width+10)" :formatter="formatItems"
                    align="right" header-align="right"
                    sortable :sort-orders="['descending', 'ascending', null]"
                    > </el-table-column>
            </el-table>

            <!-- <el-table v-show="false" class="grayTableTile" v-loading="listLoading" :data="tableData.records" ref="report-table"
                max-height="650"
                fit show-summary
                :summary-method="getSummaries"
                sum-text="汇总"
                :default-sort = "{prop: 'daytime', order: 'descending'}"
                :cell-style = "markColumn"
                :header-cell-style = "markHeader"
            >
                <el-table-column v-for="(itemtable,index) in tableData.headers" :key="itemtable.id" :label="itemtable.label" 
                    :property="itemtable.property" :min-width="(itemtable.width+10)" :formatter="formatItems"
                    align="right" header-align="right"
                    sortable :sort-orders="['descending', 'ascending', null]"
                    > </el-table-column>
            </el-table> -->

        </el-card>

        <!-- 趋势图 -->
        <el-row class="chart-box" :gutter="5" style="margin-top:15px">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-card class="item-box" shadow="never">
                <div slot="header" class="title-box">
                    <span class="title">每日汇总</span>
                    <el-select
                    v-model="dailysummrayOptionSelected"
                    collapse-tags
                    style="width: 200px;float: right; margin-top: -10px"
                    placeholder=""
                    @change="changeDailySummaryMetric"
                    >
                    <el-option
                        v-for="item in dropdownOptions.summaryOptions"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                    </el-select>
                </div>
                <div v-loading="metricsSummaryLoading">
                    <UALineChart :chartData="chartDailySummaryData"></UALineChart>
                </div>
                </el-card>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-card class="item-box" shadow="never">
                <div slot="header" class="title-box">
                    <span class="title">同期群趋势</span>
                    <el-select
                    v-model="cohortTrendsOptionSelected"
                    collapse-tags
                    style="width: 200px;float: right; margin-top: -10px"
                    placeholder=""
                    @change="changeTrendsMetric"
                    >
                    <el-option
                        v-for="item in dropdownOptions.trendsOptions"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                    </el-select>
                </div>
                <div v-loading="metricsCohortLoading">
                    <UALineChart :chartData="chartCohortTrendsData" ></UALineChart>
                </div>
                </el-card>
            </el-col>
        </el-row>


        <!-- 编辑指标 -->
        <norm-filter ref="norm" :sourceData="recordsList" @handleSave="quedingshaixuan"></norm-filter>

    </div>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";

import Pagination from '@/components/Pagination'
import { parseTime } from '@/utils'
import moment from 'moment'
import {find_totalData, find_uAReportData, find_uARecordsHeader, find_condition, sync_headerData, find_channelByPermissions, find_userSource,ajax_filterGame, gamelist,find_gameList,find_oneIdConfig } from '@Sys~/api/sys'
// import {ajax_gamelist } from '@Sys~/api/user'
import NormFilter from './components/normFilter'
import UALineChart from './components/UALineChart'

import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
    name: name,
    components:{Pagination, NormFilter, UALineChart},

    data() {
        return {
            if_show:!(this.$store.getters.userId == '1517' || this.$store.getters.userId == '1518' || this.$store.getters.userId == '1519'),
            dataRefresh: false,
            dialogTipsVisible: false,
            gridTipsData:[
{metric:'毛利润', desc:'活跃用户合计利润，收入 - 成本', id_type:'设备', title:'毛利润'},
{metric:'收入', desc:'活跃用户总付费', id_type:'设备', title:'收入'},
{metric:'iOS渠道后收入', desc:'扣除了渠道分成后的收入数据。例如：iOS分给App Store 30%的收入，iOS渠道后收入 = 收入 * （1-30%）', id_type:'设备', title:'iOS渠道后收入'},
{metric:'花费', desc:'UA广告买量消耗', id_type:'设备', title:'花费'},
{metric:'ROI', desc:'ROI = 累计收入 / 花费。衡量推广的盈利亏损状态（此处仅指广告推广），ROI＞1，则产品在扣除推广费用后仍处于盈利状态；ROI＜1，则产品收支不平衡，未收回推广成本，仍处于亏损状态。', id_type:'设备', title:'ROI'},
{metric:'回本周期', desc:'新增设备累计收入≥ 花费时，所需要的天数', id_type:'设备', title:'回本周期'},
{metric:'激活设备', desc:'首次打开游戏SDK初始化完成的设备。时间点在“新增”设备之前，是相对较浅的前端的转化行为。', id_type:'设备', title:'激活设备'},
{metric:'新增设备', desc:'有（账号或角色）登陆行为的设备。时间点在“激活”设备之后，是相对较深的服务器端的转化行为。', id_type:'设备', title:'新增设备'},
{metric:'CPI', desc:'花费/激活设备数', id_type:'设备', title:'CPI'},
{metric:'CPA', desc:'花费/新增设备数', id_type:'设备', title:'CPA'},
{metric:'自然量占比', desc:'UA以外的新增设备占大盘全体的比例', id_type:'设备', title:'自然量占比(%)'},
{metric:'DAU（付费人群）', desc:'注册之日起有过付费行为的日活跃人数', id_type:'设备', title:'DAU（付费人群）'},
{metric:'DAU', desc:'日活跃人数', id_type:'设备', title:'DAU'},
{metric:'ARPU', desc:'收入/DAU', id_type:'设备', title:'ARPU'},
{metric:'ARPPU', desc:'收入/当日付费人数', id_type:'设备', title:'ARPPU'},
{metric:'付费人数', desc:'活跃付费人数', id_type:'设备', title:'付费人数'},
{metric:'付费渗透率', desc:'付费渗透率（%）=付费人数 / DAU', id_type:'设备', title:'付费渗透率(%)'},
{metric:'人均付费次数', desc:'总付费次数 / 总付费人数', id_type:'设备', title:'人均付费次数'},
{metric:'首充人数', desc:'所有活跃用户中，首次付费的人数', id_type:'设备', title:'首充人数'},
{metric:'ROI-N', desc:'新增设备在激活起N天内，累计收入-N / 花费。汇总行仅统计有完整N天收入和花费的设备。例如：设备A，仅有2天的收入，那么在ROI-3中，则不会统计设备A的收入和花费', id_type:'设备', title:'ROI-N'},
{metric:'留存率-N', desc:'新增设备在激活第N天，活跃数/新增设备', id_type:'设备', title:'留存率(%)-N'},
{metric:'LTV-N', desc:'单用户生命周期价值。新增设备在激活起N天内，LTV-N=累计收入-N / 新增设备', id_type:'设备', title:'LTV-N'},
{metric:'付费用户转化率-N', desc:'新增设备在激活起N天内付费人数/新增设备', id_type:'设备', title:'付费转化率(%)-N'},
{metric:'累计收入-N', desc:'生命周期累计收入。新增设备在N天内，累计收入', id_type:'设备', title:'累计收入-N'},
{metric:'累计收入', desc:'所选时间内新增设备，自激活日期起至['+moment().subtract(1, 'days').format('YYYY-MM-DD')+']，累计收入。例：用户在5月1日，查询游戏1.1-1.31的数据，累计收入（截至昨日），代表1.1-1.31的新增设备，截至4.30日，产生的收入总和。', id_type:'设备', title:'累计收入'}
            ],

            query_filters_last: {},
            dataloading: false,

            metricsDef: {},

            metricsSummaryLoading: true,
            metricsCohortLoading: true,
            dailysummrayOptionSelected: '',
            cohortTrendsOptionSelected: '',

            chartDailySummaryData : {},
            chartDailySummaryDataList: {},

            chartCohortTrendsData : {},
            chartCohortTrendsDataList: {},

            dropdownOptions: {
                summaryOptions: [],
                trendsOptions: [],
            },

            update_time:"",

            dayTimes: [moment().subtract(15, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],

           // 时间范围 快捷键
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = moment().toDate();
                            const start = moment().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(1, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '过去7天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(7, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去14天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(14, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去30天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(30, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '上周',
                        onClick(picker) {

                        //获取当前时间
                        var currentDate = new Date();
                        //返回date是一周中的某一天
                        var week = currentDate.getDay();
                        //返回date是一个月中的某一天
                        var month = currentDate.getDate();
                        //一天的毫秒数
                        var millisecond = 1000 * 60 * 60 * 24;
                        //减去的天数
                        var minusDay = week != 0 ? week - 1 : 6;
                        //获得当前周的第一天
                        var currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay));
                        //上周最后一天即本周开始的前一天
                        var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
                        //上周的第一天
                        var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));
                        var sy = priorWeekFirstDay.getFullYear();
                        var sm = priorWeekFirstDay.getMonth();
                        var sd = priorWeekFirstDay.getDate();
                        var ey = priorWeekLastDay.getFullYear();
                        var em = priorWeekLastDay.getMonth();
                        var ed = priorWeekLastDay.getDate();

                        var start = new Date(sy, sm,sd)
                        var end = new Date(ey, em,ed);
                        picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '本月',
                        onClick(picker) {
                            const end = moment().toDate();
                            const start = moment().startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '上个月',
                        onClick(picker) {
                            const end = moment().subtract(1, 'month').endOf('month').toDate();
                            const start = moment().subtract(1, 'month').startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '近3个月',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(2, 'month').startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                // 当前日期之前的日期不可选
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            groupBy: 'date', // 分析维度
            groupByOptions: [],

            appkey: '', // 当前游戏
            appkeys: [], // 当前游戏 [] 多选
            gameOptions:[], // 游戏列表

            media:[], // 当前媒体
            mediaOptions:[], // 媒体列表

            client_os:[], // 当前平台
            client_osOptions:[{id:1,name:'Android',disabled:false},{id:2,name:'iOS',disabled:false}], // 平台列表

            advertiserIds: [], // 当前媒体
            advertiserIdsOptions:[], // 媒体列表
            advertiserIdsOptionsAll:[], // 媒体列表总数据

            campaignIds: [], // 当前广告组
            campaignIdsOptions:[], // 广告组列表
            campaignIdsOptionsAll:[], // 广告组列表总数据

            adIds: [], // 当前广告计划
            adIdsOptions: [], // 广告计划列表
            adIdsOptionsAll:[], // 广告计划列表总数据

            creativeIds:[], // 当前广告创意
            creativeIdsOptions: [], // 广告创意列表
            creativeIdsOptionsAll:[], // 广告创意列表总数据

            // 结果过滤
            normOptions:[], // 指标列表
            symbolOptions:['=','!=','<','>','>=','<='], // 符合列表
            norm:'', // 当前指标
            symbol:'', // 符号
            normValue:'',// 指标数值

            // 用户来源
            userSources: [],
            userSourceOptions:[{
                label: '用户来源',
                options: [
                {id:'ua',name:'UA广告渠道', desc:"(UA分包&监测归因结果)"},
                {id:'uaPkg', name:'UA分包', desc:"(BDC“北京_广告”推广包)"},
                {id:'other', name:'分包渠道', desc:"(大盘全体 - UA分包)"},
                {id:'all',name:'大盘全体', desc:""},
                {id:'organic', name:'自然量', desc:'(大盘全体-UA广告渠道)'}
                ]
            }],
            userSource: '',

            listLoading: false,
            tableData:{
                headers:[],
                records:[],
                recordsSum:{},
            },
            total:0,
            listQuery:{
                pageNo: 1,
                pageSize: 500
            },
            recordsSumRow:{},

            // 所有指标 
            recordsList:[],
            headerOrder:['profit','revenue','iosChnRev','androidChnRev','cost','sumRoi','pbp','installs','deviceRegCnt','cpi','cpa'],//,'naturalRate'

            downloadLoading: false,
            headerFieldsForDownload: [],
            headerFieldsNameForDownload: [],
            isOpenMore: false, // 是否显示更多筛选
            btnOpenMore: undefined,
            disabledAdFilter: false,

            // maybe 
            queryType: 3, // 计算维度。后端逻辑限定为设备
            dateType: 'day', // 时间范围筛选。后端逻辑限定为 天:day
            monthTimes: [new Date().Format("yyyy-MM"), new Date().Format("yyyy-MM")],
            typesOptions:[{id:1,name:'BDC'},{id:0,name:'其他'}],
            types: [],
        }
    },

    created() {
        this.getGroup() // 查询数据维度
        this.oneidInit()
        // this.getCommonChannel() // 获取公共渠道列表
        // 获取游戏列表
        // this.getList() // getGameList是异步，故getList放到getGameList方法内部执行
         
    },

    watch: {
        // 监听appks 变化
        appkey() {
            this.appkeys = [this.appkey]
            this.advertiserIds = [] // 当前媒体
            this.campaignIds = [] // 当前广告组
            this.adIds = [] // 当前广告计划
            this.media = []
            this.creativeIds = [] // 当前广告创意
            this.userSource = ""
            this.getCommonChannel() // 获取公共渠道列表
            this.userSourcesList()
        },

        // media() {
        //     this.changeBtnColor()
        // },

        // 监听媒体advertiserIds 变化
        advertiserIds() {
            this.campaignIds = [] // 当前广告组
            this.adIds = [] // 当前广告计划
            this.creativeIds = [] // 当前广告创意
        },

        // 监听当前广告组campaignIds变化
        campaignIds() {
            this.adIds = [] // 当前广告计划
            this.creativeIds = [] // 当前广告创意
        },

        // 监听当前广告计划 adIds 变化
        adIds() {
            this.creativeIds = [] // 当前广告创意
            // this.changeBtnColor()
        },

        dataRefresh(){
            if(this.dataRefresh){
                this.$nextTick(() => {
                    this.$refs.tableAggrReportDataRef.doLayout();
                    this.dataRefresh = false
                });
            }
        },

        userSource(){
            this.getGroup()
            this.media = []
            this.advertiserIds = []
            if(this.userSource != 'ua'){
                this.disabledAdFilter = true
            }else{
                this.disabledAdFilter = false
            }
            if(this.userSource == 'other'){
                this.client_os = [1]
                this.client_osOptions.forEach(r => {
                    if(r.id == 2){
                        r.disabled = true
                    }
                })
            }else{
                this.client_osOptions.forEach(r => {
                    if(r.id == 2){
                        r.disabled = false
                    }
                })
            }
        },
    },

    methods: {
        // oneid初始化
        oneidInit() {
        find_oneIdConfig().then(response => {
            if (response.code == 1) {
                this.oneid_info = response.data
            }
            this.getGameList()
        })
        },
        userSourcesList(){
            find_userSource({appkeys:this.appkeys,projectCode:'ua'}).then(response => {
                console.log(response)
                if (response.code == 1) {
                    this.userSourceOptions = response.data
                    if(this.userSourceOptions.length>0){
                        this.userSource = this.userSourceOptions[0].value
                    }
                    this.getList() 
                }
            })
        },

        changeBtnColor(){
            if(this.btnOpenMore == undefined){
                this.btnOpenMore = document.getElementById("extend_button")
            }
            if(this.advertiserIds.length>0 || this.campaignIds.length>0 || this.adIds.length>0 || this.creativeIds.length>0){
                this.btnOpenMore.style.setProperty('background','#e6f1ff');
                this.isOpenMore = true
            }else{
                this.btnOpenMore.style.setProperty('background','');
                this.isOpenMore = false
            }
        },

        // 查询数据维度
        getGroup() {
            this.groupByOptionsALL = [
                {title: "日期", value: "date", propName:"daytime", propId: "", displayColumnWidth: 90, disabled:false},
                // {title: "用户来源", value: "userSource", propName:"userSource", propId: "", displayColumnWidth: 100, disabled:false},
                {title: "平台", value: "clientOs", propName:"clientOsName", propId: "", displayColumnWidth: 90, disabled:false},
                // {title: "媒体", value: "channel", propName:"mediaName", propId: "", displayColumnWidth: 100, disabled:false},
                // {title: "媒体账号", value: "advertiserId", propName:"advertiserName", propId: "advertiserId", displayColumnWidth: 200, disabled:false},
                // {title: "广告组", value: "campaignId", propName:"campaignName", propId: "campaignId", displayColumnWidth: 200, disabled:false},
                // {title: "广告计划", value: "adId", propName:"adName", propId: "adId", displayColumnWidth: 220, disabled:false},
                // {title: "广告创意", value: "creativeId", propName:"creativeName", propId: "creativeId", displayColumnWidth: 220, disabled:false},
                // {title: "广告素材", value: "materialId", propName:"materialName", propId: "materialId", displayColumnWidth: 100, disabled:false},
                // {title: "国家", value: "country", propName:"", propId: "", displayColumnWidth: 90, disabled:false},
            ]

            if(this.userSource == 'uaPkg' || this.userSource == 'all' || this.userSource == 'other' || this.userSource == ''){
                this.groupByOptions = this.groupByOptionsALL.filter((g) => {
                    return ['date', 'clientOs'].indexOf(g.value) > -1;
                });
                // this.groupByOptions.forEach(itm => {
                //     if(['date', 'clientOs'].indexOf(itm.value) === -1){
                //         itm.disabled = true
                //     }
                // })
            }
            else{
                this.groupByOptions = [].concat(this.groupByOptionsALL)
            }
            
            let testEx = this.groupByOptions.filter((g) => {
                return g.value == this.groupBy;
            });
            if(testEx.length <= 0){
                this.groupBy = "date"
            }else{
                this.groupBy = this.groupBy
            }

            return

            // find_groupBy().then(response => {
            //     if(response.code == 1) {
            //         this.groupByOptions = response.data.concat([{title: "日期", value: "daytime"}])
            //         this.groupBy = "advertiser_id"
            //     }
            // })
        },


        // 获取游戏列表
        getGameList() {
            // gamelist('').then(response => {
            //     if(response.code == 1) {
            //         this.gameOptions = response.data
            //         this.appkey = this.gameOptions[0].appkey

            //         // let lszt = this.gameOptions.filter((g) => {
            //         //     return g.appkey == "1aa9c860218b4e739af1e0fcc7c5a533";
            //         // });
            //         // if(lszt.length > 0){
            //         //     this.appkey = "1aa9c860218b4e739af1e0fcc7c5a533";
            //         // }

            //         // this.getFilterData(1,'advertiser_id');

            //         this.appkeys = [this.appkey]
            //         this.getCommonChannel() // 获取公共渠道列表
            //         this.userSourcesList()
            //     }
            // })

            find_gameList().then(response => {
                if(response.code == 1) {
                    this.gameOptions = response.data
                    this.appkey = this.gameOptions[0].appkey

                    this.appkeys = [this.appkey]
                    this.getCommonChannel() // 获取公共渠道列表
                    this.userSourcesList()
                }
            })
        },

        // 获取公共渠道列表
        getCommonChannel() {
            find_channelByPermissions({appkeys:this.appkeys,projectCode:'ua'}).then(response => {
                if (response.code == 1) {
                    this.mediaOptions = response.data
                }
            })
        },

        // 查询筛选项
        getFilterData(e, code) {
            if(e) {
                let data = {}
                var media = JSON.parse(JSON.stringify(this.media));
                var mediavalue=[];
                media.forEach(function (item,i){
                    mediavalue.push(item[item.length-1])
                })
                if(code == 'advertiser_id') { // 查询媒体账号列表
                    data = {
                        condition: code,
                        appkeys: this.appkeys,
                        medias: mediavalue
                    }

                } else if(code == 'campaign_id') { // 广告组
                    data = {
                        condition: code,
                        appkeys: this.appkeys,
                        medias: mediavalue,
                        advertiserIds: this.advertiserIds
                    }

                } else if(code == 'ad_id') { // 广告计划
                    data = {
                        condition: code,
                        appkeys: this.appkeys,
                        medias: mediavalue,
                        advertiserIds: this.advertiserIds,
                        campaignIds: this.campaignIds
                    }

                } else if(code == 'creative_id') { // 广告创意
                     data = {
                        condition: code,
                        appkeys: this.appkeys,
                        medias: mediavalue,
                        advertiserIds: this.advertiserIds,
                        campaignIds: this.campaignIds,
                        adIds: this.adIds
                    }
                }

                find_condition(data).then(response => {
                    if(response.code == 1) {
                        if(code == 'advertiser_id') { // 查询媒体账号列表
                            this.advertiserIdsOptions = response.data.slice(0,200)
                            this.advertiserIdsOptionsAll = response.data

                        } else if(code == 'campaign_id') { // 广告组
                            this.campaignIdsOptions = response.data.slice(0,200)
                            this.campaignIdsOptionsAll = response.data

                        } else if(code == 'ad_id') { // 广告计划
                            this.adIdsOptions = response.data.slice(0,200)
                            this.adIdsOptionsAll = response.data

                        } else if(code == 'creative_id') { // 广告创意
                            this.creativeIdsOptions = response.data.slice(0,200)
                            this.creativeIdsOptionsAll = response.data
                        }
                    }
                })
            }
        },

        // 优化 媒体账号 下拉列表数据
        filterAdvertiserIds(val) {
            this.advertiserIdsOptions = this.filterSelect(val, this.advertiserIdsOptionsAll)
        },

        // 优化 广告组 下拉列表数据
        filterCampaignIds(val) {
            this.campaignIdsOptions = this.filterSelect(val, this.campaignIdsOptionsAll)
        },

        // 优化 广告计划 下拉列表数据
        filterAdIds(val) {
            this.adIdsOptions = this.filterSelect(val, this.adIdsOptionsAll)
        },

        // 优化 广告创意 下拉列表数据
        filterCreativeIds(val) {
            this.creativeIdsOptions = this.filterSelect(val, this.creativeIdsOptionsAll)
        },

        filterSelect(val, listAll) {
        let list = []
        if (val) {
            let tok = val.toLowerCase().split(" ")
            list = listAll.filter(item => {
            let matches = 0
            for (var i=0; i<tok.length; i++ ){
                if(String(item['name']).toLowerCase().indexOf(tok[i]) > -1 || String(item['id']).indexOf(tok[i]) > -1){
                matches++
                }
            }
            if(matches == tok.length){
                return true
            }else{
                return false
            }
            })
        } else {
            list = listAll.slice(0, 200)
        }
        return list
        },

        // 获取数据列表
        getList(sortProperty='daytime',sortType='desc') {
            var media = JSON.parse(JSON.stringify(this.media));
            var mediavalue=[];
            media.forEach(function (item,i){
                mediavalue.push(item[item.length-1])
            })

            // 游戏gameKey
            let gameKeys = []
            this.gameOptions.forEach(item => {
                if(this.appkeys.indexOf(item.appkey) > -1) {
                    gameKeys.push(item.gameKey)
                }
            })
            const data = {
               startDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0],
               endDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1],

               groupBy: [this.groupBy],

               appkeys: this.appkeys,
               gameKeys: gameKeys,
               medias: mediavalue,
               clientOs: this.userSource == 'other' ? [1] : this.client_os,
               userSource: [this.userSource],
               advertiserIds: this.advertiserIds,
               campaignIds: this.campaignIds,
               adIds: this.adIds,
               creativeIds: this.creativeIds,

               sortProperty:sortProperty, // 排序指标
               sortType:sortType, // 排序类型

               dataSourceFlag:this.oneid_info.dataSource,
            }

            this.dataloading = true
            this.query_filters_last = JSON.parse(JSON.stringify(data));

            this.listLoading = true
            this.metricsSummaryLoading = true
            this.metricsCohortLoading = true

            this.tableData.records = []
            this.tableData.recordsSum = {}
            this.chartDailySummaryData = {}
            this.chartCohortTrendsData = {}
            this.chartDailySummaryDataList = []
            this.chartCohortTrendsDataList = []

            find_uAReportData(data).then(response => {
                this.dataRefresh = true
                this.listLoading = false
                if(response.code == 1 && response.data !== null) {
                    this.tableData.records = this.parseResponseData(response.data.records) // TODO change metrics value from string to digital
                    this.tableData.headers = this.buildHeaders(response.data.headers)
                    this.dataloading = false

                    if(this.query_filters_last.groupBy[0] == "date"){
                        this.buildTrendMetrics(response.data)
                    }
                }else{
                    this.dataloading = false
                    this.metricsSummaryLoading = false
                    this.metricsCohortLoading = false
                }
            })

            if(this.query_filters_last.groupBy[0] != "date"){
                this.find_uAReportDataTrend(data)
            }

            let data2 = JSON.parse(JSON.stringify(data));
            // data2.totalType = 'uaPkgTotal' // (N/A)
            // if(this.userSource == 'ua'){
            //     data2.totalType = 'uaTotal' // OK
            // }
            data2.totalType = this.userSource
            data2.groupBy = ['date']
            find_totalData(data2).then(response2 => {
                this.tableData.recordsSum = response2.data.recordsSum
            })
        },

        parseResponseData(records){
            const newrec = []
            records.forEach(row => {
                if(this.query_filters_last.groupBy[0] != 'date' && parseInt(row.dau) <= 0 && parseInt(row.deviceRegCnt) <= 0 && parseFloat(row.cost) <= 0){
                    return
                }
                
                for(var key in row){
                    if(key.indexOf('Name') > -1 || key == 'daytime'){
                        continue
                    }
                    if(null === row[key] || "" == row[key]){
                        row[key] = 0
                    }
                    if(parseFloat(row.cost) <= 0 && (key.indexOf('roi') === 0 || key == 'sumRoi')){
                        row[key] = '-'
                    } else {
                        if(row[key] != '-'){
                            if(row[key].toString().indexOf('%') == -1) {
                                row[key] = parseFloat(row[key])
                            }
                        }
                        // TODO 使用headers定义 或 API返回数字型结果
                    }
                }
                newrec.push(row)
            })

            // sort
            if(this.query_filters_last.groupBy[0] != 'date'){
                newrec.sort(this.sortByMulti(['cost', 'deviceRegCnt', 'dau'], false))
            }else{
                newrec.sort((a, b)=>{return b.daytime.localeCompare(a.daytime)})
            }

            return newrec
        },

        sortByMulti(arr, rev) {
            if (rev == undefined) {
                rev = 1
            } else {
                rev = (rev) ? 1 : -1
            }
            return function(a, b) {
                for (var i = 0; i < arr.length; i++) {
                    let attr = arr[i]
                    if (parseFloat(a[attr]) != parseFloat(b[attr])) {
                        if (parseFloat(a[attr]) > parseFloat(b[attr])) {
                            return rev * 1
                        } else {
                            return rev * -1
                        }
                    }
                }
            }
        },

        find_uAReportDataTrend(data){
            this.metricsSummaryLoading = true
            this.metricsCohortLoading = true

            let dataDaily = JSON.parse(JSON.stringify(data));
            dataDaily.groupBy = ['date']
            find_uAReportData(dataDaily).then(response => {
                if(response.code == 1 && response.data !== null) {
                    this.buildTrendMetrics(response.data)
                }
            })
        },

        // 查询
        handleFilter() {
            if(moment().format('YYYY-MM-DD') == this.dayTimes[1]){
                this.update_time = "数据更新至：<span style='color:#1890ff;'>"+ moment().subtract(2, 'hours').format('YYYY-MM-DD HH:mm:ss')+"</span>"
            }else{
                this.update_time = ""
            }
            this.dataloading = true
            this.getList()
        },

        // 合计
        getSummaries(param) {
            var sums = [];
            var zongji = this.tableData.recordsSum;
            // zongji['cpi'] = parseInt(zongji['installs']) > 0 ? parseFloat(zongji['cost']) / parseInt(zongji['installs']) : null
            var theads = param.columns;
            for (var i = 0; i < theads.length; i++) {
                var istrue = false;
                for (var j in zongji) {
                    if (theads[i].property == j) {
                        let x = zongji[j]
                        let property = j
                        if(i == 0){
                            sums.push('汇总')
                            this.recordsSumRow[theads[i].property] = '汇总'
                        }else{
                            let k = property.replace(/[0-9]/g, '').toLowerCase()
                            sums.push(this.formatData(x, property))

                            let subfix = this.calcSubfix(property)
                            if(subfix == 0){
                                this.recordsSumRow[theads[i].property] = parseInt(x)
                            }else{
                                this.recordsSumRow[theads[i].property] = parseFloat(x)
                            }
                        }
                        istrue = true;
                    }
                }
                if (!istrue) {
                    sums.push('')
                    this.recordsSumRow[theads[i].property] = ''
                }
            }

            this.dataRefresh = true
            return sums
        },
        
        // 编辑指标
        handleEditNorm() {
            this.$refs['norm'].init()
            this.getUaRecords()
        },

        // 查询指标
        getUaRecords(){
            find_uARecordsHeader().then(response => {
                this.$refs['norm'].loading = false
                if(response.code == 1){
                    const data = JSON.parse(JSON.stringify(response.data))
                    data.forEach(arr => {
                        let nums = 0;
                        arr.children.forEach(item => {
                            if(item.checked) {
                                nums++
                            }
                        })

                        if(nums == arr.children.length) {
                            arr.checked = true
                        } else {
                            arr.checked = false
                        }
                    })

                    // this.$refs['norm'].sourceData = data
                    this.recordsList = data
                }
            })
        },

        // 确定编辑指标
        quedingshaixuan(list) {
            const ids = []
            list.forEach(item => {
                if(item.children && item.children.length > 0) {
                    item.children.forEach(item => {
                        if(item.checked) {
                            ids.push(item.id)
                        }
                    })
                }
            })

            const data = {
                projectCode: 'ua_report',
                ids: ids
            }
            sync_headerData(data).then(response => {
                this.$refs['norm'].dialogLoading = false
                if(response.code == 1) {
                   this.$refs['norm'].dialogTableVisible = false
                    this.getList();
                }
            })
        },

        // 根据response返回结果，创建特定表头
        buildHeaders(list){
            let firstCol = {}
            this.groupByOptionsALL.forEach( grpitem => {
                if(grpitem.value == this.query_filters_last.groupBy[0]){
                    firstCol = {
                        label: grpitem.title,
                        property: grpitem.propName,
                        sortFlag: true,
                        id: grpitem.propName,
                        width: grpitem.displayColumnWidth
                    }
                }
            })

            const headers = [firstCol]
            // this.headerFieldsForDownload = [firstCol.property]
            // this.headerFieldsNameForDownload = [firstCol.label]

            const fixCols = {}
            const otherCols = []


            var curDay = moment()
            var queryStartDay = moment(this.query_filters_last.startDate)
            var LT = curDay.diff(queryStartDay, 'days')
            list.forEach(item => {
                if(item.children && item.children.length > 0) {
                    item.children.forEach(item => {
                        if(['daytime', 'totalRoi'].indexOf(item.property) > -1 ) {return}
                        if(['naturalRate'].indexOf(item.property) > -1 ) {return}
                        if(true || item.checked) {
                            let label = item.label

                            let k = item.property.replace(/[0-9]/g, '').toLowerCase()
                            let d = item.property.replace(/[^0-9]/ig, '')
                            let dayIndex = parseInt(d)
                            if( ['ltv','roi','pur','remain','rr','rev'].indexOf(k) > -1 && dayIndex > LT ){
                                return
                            }

                            let tmplen = label.replace(/[\u0391-\uFFE5]/g,"aa").length;
                            let colwidth = 100
                            if(tmplen > 8){
                                colwidth = colwidth + (tmplen - 8)*10
                            }

                            let coldef = {
                                label: label,
                                property: item.property,
                                sortFlag: item.sortFlag,
                                width: colwidth
                            }
                            if(this.headerOrder.indexOf(item.property) > -1){
                                fixCols[item.property] = coldef
                            }else{
                                otherCols.push(coldef)
                            }
                        }
                    })
                }
            })

            const fixColsOrdered = []
            this.headerOrder.forEach(it => {
                if(fixCols[it]) {
                    fixColsOrdered.push(fixCols[it])
                }
            })
           
            var finalCols = headers.concat(fixColsOrdered).concat(otherCols)

            console.log('111表头：', finalCols)

            this.headerFieldsNameForDownload = []
            this.headerFieldsForDownload = []
            finalCols.forEach(coldef => {
                this.headerFieldsForDownload.push(coldef.property)
                this.headerFieldsNameForDownload.push(coldef.label)
            })

            return finalCols
        },

        // 根据response返回结果，构建summay和cohort的指标
        buildTrendMetrics(data){
            // build metrics
            let summaryOptions = []
            let summaryFields = []
            data.headers.forEach(item => {
                if(item.children && item.children.length > 0) {
                    item.children.forEach(item => {
                        if(true || item.checked) {
                            if(item.property == 'daytime'){
                                return
                            }
                            if(item.property == 'totalRoi'){
                                return
                            }
                            let k = item.property.replace(/[0-9]/g, '').toLowerCase()
                            if(['ltv','roi','pur','remain','rr','rev'].indexOf(k) === -1){
                                let label = item.label

                                // TODO delete. use server-side data
                                if(item.property == 'cost'){
                                    if (this.userSource == 'other') { // 分包渠道
                                        label = '成本'
                                    }
                                }
                                summaryOptions.push(
                                    {
                                        text: label,
                                        value: item.property
                                    }
                                )
                                summaryFields.push(item.property)
                            }
                            this.metricsDef[item.property] = item
                        }
                    })
                }
            })
            let trendsOptions = [{value:'roi', text:'ROI(%)'}, {value:'remain', text:'留存率(%)'}, {value:'ltv', text:'LTV'}, {value:'pur', text:'付费转化率(%)'}]
            this.dropdownOptions.summaryOptions = summaryOptions
            this.dropdownOptions.trendsOptions = trendsOptions

            // build series data
            let recordsSorted = data.records.concat([])
            recordsSorted.sort((a, b)=>{return a.daytime.localeCompare(b.daytime)})
            let xAxisData = []
            recordsSorted.forEach(item => {
                xAxisData.push(item.daytime)
            })

            this.chartDailySummaryDataList = this.buildChartDataSummary(recordsSorted, summaryFields)
            this.chartCohortTrendsDataList = this.buildChartDataCohort(recordsSorted, summaryFields)

            console.log("编译测试！！！！！！！！")

            if(this.dailysummrayOptionSelected == ''){
                this.dailysummrayOptionSelected = (Object.keys(this.chartDailySummaryDataList))[0] //'deviceRegCnt' //'installs'
            }

            if(this.cohortTrendsOptionSelected == ''){
                this.cohortTrendsOptionSelected = 'remain'
            }
            this.changeDailySummaryMetric()
            this.changeTrendsMetric()

            this.metricsSummaryLoading = false
            this.metricsCohortLoading = false
        },

        buildChartDataCohort(recordsSorted, summaryFields){
            let result = {}
            let xAxisData = []
            let legendData = []
            let seriesDataTmp = {} // data
            let targetDay = [1, 2, 3, 7, 14, 30, 60, 90]

            recordsSorted.forEach(item => {
                xAxisData.push(item.daytime)
            })

            recordsSorted.forEach(row => {
                for(var key in row){
                    let k = key.replace(/[0-9]/g, '').toLowerCase()
                    let d = key.replace(/[^0-9]/ig, '')
                    let dayIndex = parseInt(d)
                    // if( ['remain','rr'].indexOf(k) > -1 ){
                    //     dayIndex -= 1
                    // }
                    if( ['ltv','roi','pur','remain','rr','rev'].indexOf(k) > -1 && targetDay.indexOf(dayIndex) > -1 ){ // 
                        if( !seriesDataTmp.hasOwnProperty(k) ){seriesDataTmp[k] = {}}
                        if( !seriesDataTmp[k].hasOwnProperty('D'+d) ){seriesDataTmp[k]['D'+d] = []}
                        let val = parseFloat(row[key])
                        val = val == 0 ? undefined : val
                        seriesDataTmp[k]['D'+d].push(val)
                    }
                }
            })

            targetDay.forEach(d => {
                legendData.push('D'+d)
            })

            // console.log(xAxisData)
            // console.log(legendData)
            // console.log(seriesDataTmp)
            for(var kpi in seriesDataTmp){
                let seriesData2 = []
                for(var day in seriesDataTmp[kpi]){
                    seriesData2.push({
                        name: day,
                        data: seriesDataTmp[kpi][day],
                        smooth: true,
                        type: 'line',
                        symbolSize: 4,
                        lineStyle: { width: 2 },
                        animation: false,
                    })
                }
                result[kpi] = {
                    xAxisData: xAxisData,
                    legendData: legendData, 
                    seriesData: seriesData2,
                }
            }
            return result
        },

        buildChartDataSummary(recordsSorted, summaryFields){
            let xAxisData = []
            recordsSorted.forEach(item => {
                xAxisData.push(item.daytime)
            })

            let seriesData = {}
            summaryFields.forEach(field => {
                let data = []
                recordsSorted.forEach(item => {
                    data.push(item[field]) // todo number
                })
                let name = this.metricsDef[field]['label']
                let chartData = {
                    xAxisData: xAxisData,
                    legendData: [name],
                    seriesData: [
                        {
                            name: name,
                            data: data,
                            smooth: true,
                            type: 'line',
                            symbolSize: 4,
                            lineStyle: { width: 2 },
                            animation: false,
                        }
                    ]
                }
                seriesData[field] = chartData
            })
            return seriesData
        },

        changeDailySummaryMetric(){
            this.chartDailySummaryData = this.chartDailySummaryDataList[this.dailysummrayOptionSelected]
        },

        changeTrendsMetric(){
            this.chartCohortTrendsData = this.chartCohortTrendsDataList[this.cohortTrendsOptionSelected]
        },

        formatItems(row, column, cellValue, index){
            let x = row[column.property]

            // 如果在group的列表内，则不进行格式化
            let tmp = this.groupByOptionsALL.filter((g) => {
                return g.propName == column.property
            });
            if(tmp.length > 0){
                return x
            }

            // if(column.property == 'cpi'){
            //     x = parseInt(row['installs']) > 0 ? parseFloat(row['cost']) / parseInt(row['installs']) : null
            // }

            return this.formatData(x, column.property, row['daytime'])
        },
        formatData(x, property, rowdate = '汇总'){
            if(this.query_filters_last.groupBy[0] == 'date' && rowdate != '汇总'){
                var curDay = moment()
                var queryStartDay = moment(rowdate)
                var LT = curDay.diff(queryStartDay, 'days')
                let k = property.replace(/[0-9]/g, '').toLowerCase()
                let d = property.replace(/[^0-9]/ig, '')
                let dayIndex = parseInt(d)
                if( ['ltv','roi','pur','remain','rr','rev'].indexOf(k) > -1 && dayIndex > LT ){
                    return null
                }
            }

            if(x == null || x == '-'){
                return x
            }

            if(parseFloat(x.toString()) == 0){ // TODO replace %
                return 0
            }
            
            // % 直接返回
            if(x.toString().indexOf('%') > -1) {
                return x
            }

            let subfix = this.calcSubfix(property)
            let parts = (parseFloat(x.toString().replace(/[^\-\d\.]/g, "")).toFixed(subfix) + "").split("."); 
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            return parts.join(".")
        },

        calcSubfix(property){
            let subfix = 0
            let k = property.replace(/[0-9]/g, '').toLowerCase()
            if( ['ltv','roi','pur','remain','rr','rev'].indexOf(k) > -1 ){
                subfix = 2
            }
            if( ['cpa','cpi','ctr','cvr','ecpi','arpu','arppu', 'chargepermeate','naturalRate'].indexOf(k) > -1 ){
                subfix = 2
            }
            if (['cost', 'revenue', 'profit', 'regPaySum', 'actPaySum', 'userAvgChargeCnt'].indexOf(property.toString()) >= 0) {
                subfix = 2
            }
            if(['totalCharge','iosChnRev','androidChnRev'].indexOf(property.toString()) >= 0) {
                subfix = 2
            }
            return subfix
        },

        markColumn({row, column, rowIndex, columnIndex}){
            let sty = '';
            let x = row[column.property]
            if(columnIndex === 0){
                sty = "text-align: left;"
            }else{
                return ""
            }
            // when GROUPBY date
            if(column.property === 'daytime'){
                let d = new Date(x);
                if(d.getDay() == 0 || d.getDay() == 6){
                    sty += "background: whitesmoke;"
                }
            }
            return sty
        },

        markHeader({row, column, rowIndex, columnIndex}){
            let sty = '';
            if(columnIndex === 0){
                sty = "text-align: left;"
            }else{
                return ""
            }
            return sty
        },

        handleDownload() {
            this.downloadLoading = true
            // 汇总
            let recordsSum = JSON.parse(JSON.stringify(this.tableData.recordsSum))
            for(let key in recordsSum) {
                // console.log( recordsSum[key] && parseFloat(recordsSum[key].toString()) == 0)
                if(recordsSum[key] && (recordsSum[key].toString().indexOf('%') > -1 || recordsSum[key].toString().indexOf('汇总') > -1 || recordsSum[key].toString().indexOf('-') > -1)) {
                    // console.log(key, recordsSum[key])
                } else {
                    recordsSum[key] = parseFloat(recordsSum[key])
                }
            }

            // 数据
            let records = JSON.parse(JSON.stringify(this.tableData.records))
            records.forEach((item,index) => {
                for(let key in item) {
                    if(this.query_filters_last.groupBy[0] == 'date'){
                        var curDay = moment()
                        var queryStartDay = moment(item['daytime'])
                        var LT = curDay.diff(queryStartDay, 'days')
                        let k = key.replace(/[0-9]/g, '').toLowerCase()
                        let d = key.replace(/[^0-9]/ig, '')
                        let dayIndex = parseInt(d)
                        if( ['ltv','roi','pur','remain','rr','rev'].indexOf(k) > -1 && dayIndex > LT ){
                            item[key] = null
                        }
                    }
                }
            })
            
            import('@/vendor/Export2Excel').then(excel => {
                const tHeader = this.headerFieldsNameForDownload
                const filterVal = this.headerFieldsForDownload
                const list = [].concat(records).concat(recordsSum)
                const data = this.formatJson(filterVal, list)
                const tmpdate = 'UA周报'+parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
                excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: tmpdate,
                autoWidth: true,
                bookType: 'xlsx'
                })
                this.downloadLoading = false
            })

            // const $table = this.$refs['report-table'].$el
            // const wb = XLSX.utils.table_to_book($table, {raw:false})
            // const wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST:true, type: 'array'})
            // FileSaver.saveAs(
            //     new Blob([wbout],{type: 'application/octet-stream'}),
            //     'UA周报'+parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')+'.xlsx',
            // )

        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                return v[j]
            }))
        }

    }
}
</script>

<style lang="scss" scoped>
.filter-container{
    // display: flex;
    // flex-flow: row wrap;
    .filter-data{
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        // margin: 5px 10px 5px;
    }
    .filter-item{
        margin-bottom: 5px;
    }
    .label{
        min-width: 77px;
        font-size: 15px;
        margin-right: 3px;
        color: #7b7b7b; 
    }

    ::v-deep .el-select__tags{
        .el-tag {
            max-width: 74%;
            overflow: hidden;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            .el-select__tags-text{
                width: 100%;
                overflow: hidden;
            }
        }
        .el-select__input{
            margin-left: 2px;
        }
    }
}

.box-card{
    ::v-deep.el-card__header{
        padding: 6px 20px !important;
    }
    ::v-deep.el-card__body{
        padding: 0;
    }
} 

.checkbox-table-headers .el-checkbox{
    min-width: 150px;
}

.grayTableTile ::v-deep .el-table__body-wrapper{
    z-index: 1;
}

.dataPicker{
    position: relative;
    ::v-deep .el-picker-panel{
        position:absolute;
        top: 32px;
        z-index: 99;
    }
}
.el-dialogA {
    margin-top: 10vh;
    width: 80%;
}
.card-box{
    .item{
        margin-bottom: 18px;
    }
    .text {
        font-size: 14px;
    }
    ::v-deep .el-card__body{
        padding: 10px;
    }
}

.el-table .cell {
    padding-left: 3px;
    padding-right: 3px;
}
.el-table th>.cell {
    padding-left: 3px;
    padding-right: 3px;
}
</style>
